module.exports = __webpack_public_path__ + "media/src/admin/images/details_close-4cec7af7c319e383eebd99fec4000802.png";